import React, { useState, useEffect } from "react";
import classNames from 'classnames';
import { useNavigate } from "react-router-dom";

import { asia, europe, africa, america } from '../../_helpers/mock-data';


export const ChooseCountry = ({nav, action}) => {

    const [continent, setContinent] = useState('Europe');
    const [cData, setCData] = useState([]);

    const navigateTo = useNavigate();

    useEffect(() => {
        switch (continent) {
            case 'Europe':
                setCData(europe);
                break;
            case 'America':
                setCData(america);
                break;
            case 'Asia':
                setCData(asia);
                break;
            case 'Africa':
                setCData(africa);
                break;
            default:
                break;
        }
    }, [continent]);

    const handleClick = (v) => {
        if (nav) {
            navigateTo(`/visa-programs`,{state: {country: v}})
        }else{
            action(v)
        }
    }

    return (
        <div className='nations-container'>
            <div className={classNames('continent-bar', 'rw-al-cnt')}>
                <button 
                    className={classNames(
                        'cnt-btn',
                        {'clicked': continent === 'Europe'}
                    )}
                    onClick={() => setContinent('Europe')}
                >
                    Europe
                </button>
                <button 
                    className={classNames(
                        'cnt-btn',
                        {'clicked': continent === 'America'}
                    )}
                    onClick={() => setContinent('America')}
                >
                    N/S America
                </button> 
                <button 
                    className={classNames(
                        'cnt-btn',
                        {'clicked': continent === 'Asia'}
                    )}
                    onClick={() => setContinent('Asia')}
                >
                    Asia
                </button>
                <button 
                    className={classNames(
                        'cnt-btn',
                        {'clicked': continent === 'Africa'}
                    )}
                    onClick={() => setContinent('Africa')}
                >
                    Africa
                </button>
            </div>
            <div className='ctry-list'>
                { cData.map((d,k) => {
                    return (
                        <button
                            className='ctry-btn'
                            key={k}
                            onClick={() => handleClick(d.country)}
                        >
                            <img
                                src={d.flag}
                                alt=''
                                className='c-flag'
                            />
                            <span className='ctry-nm'>{d.country}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    );
}